import AMZLStations_ATV from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_ATV";
import AMZLStations_EU_Non_OV_To_OV from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_EU_Non_OV_To_OV";
import AMZLStations_EU_Pick_Productivity from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_EU_Pick_Productivity";
import AMZLStations_EU_PNOVRTS from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_EU_PNOVRTS";
import AMZLStations_EU_Stow_Productivity from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_EU_Stow_Productivity";
import AMZLStations_F2F_Coaching_Alert from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_F2F_Coaching_Alert";
import AMZLStations_Inducted_Not_Containerized from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Inducted_Not_Containerized";
import AMZLStations_Non_OV_To_OV from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Non_OV_To_OV";
import AMZLStations_OV_TO_BAG from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_OV_TO_BAG";
import AMZLStations_Pick_Productivity from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Pick_Productivity";
import AMZLStations_PNOVC from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_PNOVC";
import AMZLStations_PNOVRTS from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_PNOVRTS";
import AMZLStations_SD_Immediate_Action_Needed from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_SD_Immediate_Action_Needed";
import AMZLStations_SD_Trend from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_SD_Trend";
import AMZLStations_Stow_Productivity from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Stow_Productivity";
import AMZLStations_Stow_Standard_Work from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Stow_Standard_Work";
import AMZLStations_Stow_WIP_too_low from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Stow_WIP_too_low";
import AMZLStations_Stow_WIP_too_high from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Stow_WIP_too_high";
import AMZLStations_SWDNR from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_SWDNR";
import AMZLStations_Injury from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Injury";
import AMZLStations_Spill from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Spill";
import AMZLStations_Team_Lift from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Team_Lift";
import AMZLStations_Other_Help_Request from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Other_Help_Request";
import AMZLStations_LMP3_TRCreationFailure from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_LMP3_TRCreationFailure";
import AMZLStations_Aisles_At_Risk_SCC from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Aisles_At_Risk_SCC";
import AMZLStations_Help_Request_Injury from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Help_Request_Injury";
import AMZLStations_Help_Request_Spill from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Help_Request_Spill";
import AMZLStations_Help_Request_Team_Lift from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Help_Request_Team_Lift";
import AMZLStations_Multiday_Stow_Alert from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Multiday_Stow_Alert";
import AMZLStations_CO_SWA_Cubeout from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_CO_SWA_Cubeout";
import AMZLStations_CO_SWA_Early_Attempt from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_CO_SWA_Early_Attempt";
import AMZLStations_On_Time_Depart_Alert from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_On_Time_Depart_Alert";
import AMZL_DA_On_Road_Safety_Intervention from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZL_DA_On_Road_Safety_Intervention";
import AMZLStations_Stop_Signs_Coaching_for_ORSA from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Stop_Signs_Coaching_for_ORSA";
import AMZLStations_Seatebelt_Coaching_for_ORSA from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Seatebelt_Coaching_for_ORSA";
import AMZLStations_Distraction_Coaching_for_ORSA from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Distraction_Coaching_for_ORSA";
import AMZLStations_Speeding_Coaching_for_ORSA from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Speeding_Coaching_for_ORSA";
import AMZLStations_Traffic_Light_Coaching_for_ORSA from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Traffic_Light_Coaching_for_ORSA";
import AMZLStations_Following_Distance_Coaching_for_ORSA from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Following_Distance_Coaching_for_ORSA";
import AMZL_Shelter_In_Place_Tornado_Warning from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZL_Shelter_In_Place_Tornado_Warning";
import AMZL_Suspend_Outdoor_Operations_Wind_Chill from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZL_Suspend_Outdoor_Operations_Wind_Chill";
import AMZL_Suspend_Outdoor_Operations_High_Heat_Index from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZL_Suspend_Outdoor_Operations_High_Heat_Index";
import AMZL_Suspend_Outdoor_Operations_High_Winds from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZL_Suspend_Outdoor_Operations_High_Winds";
import AMZLStations_Defective_DG_Label from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Defective_DG_Label";
import IN_QC_FLEX_DP_OFFER_NON_ACK_VIOLATION from "../components/taskExecution/TaskSOP/FallbackSOPWiki/IN_QC_FLEX_DP_OFFER_NON_ACK_VIOLATION";
import IN_QC_LATE_PICKUP from "../components/taskExecution/TaskSOP/FallbackSOPWiki/IN_QC_LATE_PICKUP";
import IN_QC_LATE_MID_BLOCK_CHECKIN from "../components/taskExecution/TaskSOP/FallbackSOPWiki/IN_QC_LATE_MID_BLOCK_CHECKIN";
import EU_QC_LATE_PICKUP from "../components/taskExecution/TaskSOP/FallbackSOPWiki/EU_QC_LATE_PICKUP";
import EU_QC_LATE_MID_BLOCK_CHECKIN from "../components/taskExecution/TaskSOP/FallbackSOPWiki/EU_QC_LATE_MID_BLOCK_CHECKIN";
import EU_QC_FLEX_DP_OFFER_NON_ACK_VIOLATION_SCC from "../components/taskExecution/TaskSOP/FallbackSOPWiki/EU_QC_FLEX_DP_OFFER_NON_ACK_VIOLATION_SCC";
import SSD_LINEHAUL_PENDING_INDUCT from "../components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_LINEHAUL_PENDING_INDUCT";
import SSD_LINEHAUL_DWELLING_INDUCT from "../components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_LINEHAUL_DWELLING_INDUCT";
import SSD_LINEHAUL_PENDING_TDR from "../components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_LINEHAUL_PENDING_TDR";
import SSD_LINEHAUL_PENDING_GEOFENCE from "../components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_LINEHAUL_PENDING_GEOFENCE";
import SSD_RTS_SITE from "../components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_RTS_SITE";
import SSD_NPLB_Depart_Staged_Site from "../components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_NPLB_Depart_Staged_Site";
import SSD_NPLB_Depart_Stowed_Site from "../components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_NPLB_Depart_Stowed_Site";
import SSD_NPLB_Stow_Inducted_Site from "../components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_NPLB_Stow_Inducted_Site";
import SSD_NPLB_Stow_ProblemSolved_Site from "../components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_NPLB_Stow_ProblemSolved_Site";
import SSD_NPLB_Held_Site from "../components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_NPLB_Held_Site";
import AMXL_PRF_PROBLEM_SOLVING from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMXL_PRF_PROBLEM_SOLVING";
import AMXL_PRF_PICKING_PICKED from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMXL_PRF_PICKING_PICKED";
import AMXL_PRF_PICKING_NOT_YET_PICKED from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMXL_PRF_PICKING_NOT_YET_PICKED";
import AMXL_PRF_PACKING from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMXL_PRF_PACKING";
import AMXL_PRF_SCANNED from "../components/taskExecution/TaskSOP/FallbackSOPWiki/AMXL_PRF_SCANNED";

export const SOP_WIKI = {
  AMZLStations_ATV,
  AMZLStations_Defective_DG_Label,
  AMZLStations_EU_Non_OV_To_OV,
  AMZLStations_EU_Pick_Productivity,
  AMZLStations_EU_PNOVRTS,
  AMZLStations_EU_Stow_Productivity,
  AMZLStations_F2F_Coaching_Alert,
  AMZLStations_Inducted_Not_Containerized,
  AMZLStations_Non_OV_To_OV,
  AMZLStations_OV_TO_BAG,
  AMZLStations_Pick_Productivity,
  AMZLStations_PNOVC,
  AMZLStations_PNOVRTS,
  AMZLStations_SD_Immediate_Action_Needed,
  AMZLStations_SD_Trend,
  AMZLStations_Stow_Productivity,
  AMZLStations_Stow_Standard_Work,
  AMZLStations_Stow_WIP_too_low,
  AMZLStations_Stow_WIP_too_high,
  AMZLStations_SWDNR,
  AMZLStations_Injury,
  AMZLStations_Spill,
  AMZLStations_Team_Lift,
  AMZLStations_Other_Help_Request,
  AMZLStations_LMP3_TRCreationFailure,
  AMZLStations_Aisles_At_Risk_SCC,
  AMZLStations_Help_Request_Injury,
  AMZLStations_Help_Request_Spill,
  AMZLStations_Help_Request_Team_Lift,
  AMZLStations_Multiday_Stow_Alert,
  AMZLStations_CO_SWA_Cubeout,
  AMZLStations_CO_SWA_Early_Attempt,
  AMZLStations_On_Time_Depart_Alert,
  AMZL_DA_On_Road_Safety_Intervention,
  AMZLStations_Stop_Signs_Coaching_for_ORSA,
  AMZLStations_Seatebelt_Coaching_for_ORSA,
  AMZLStations_Distraction_Coaching_for_ORSA,
  AMZLStations_Speeding_Coaching_for_ORSA,
  AMZLStations_Traffic_Light_Coaching_for_ORSA,
  AMZLStations_Following_Distance_Coaching_for_ORSA,
  AMZL_Shelter_In_Place_Tornado_Warning,
  AMZL_Suspend_Outdoor_Operations_Wind_Chill,
  AMZL_Suspend_Outdoor_Operations_High_Heat_Index,
  AMZL_Suspend_Outdoor_Operations_High_Winds,
  IN_QC_LATE_PICKUP,
  IN_QC_FLEX_DP_OFFER_NON_ACK_VIOLATION,
  IN_QC_LATE_MID_BLOCK_CHECKIN,
  EU_QC_LATE_MID_BLOCK_CHECKIN,
  EU_QC_LATE_PICKUP,
  EU_QC_FLEX_DP_OFFER_NON_ACK_VIOLATION_SCC,
  SSD_LINEHAUL_PENDING_INDUCT,
  SSD_LINEHAUL_DWELLING_INDUCT,
  SSD_LINEHAUL_PENDING_TDR,
  SSD_LINEHAUL_PENDING_GEOFENCE,
  SSD_RTS_SITE,
  SSD_NPLB_Depart_Staged_Site,
  SSD_NPLB_Depart_Stowed_Site,
  SSD_NPLB_Stow_Inducted_Site,
  SSD_NPLB_Stow_ProblemSolved_Site,
  SSD_NPLB_Held_Site,
  AMXL_PRF_PROBLEM_SOLVING,
  AMXL_PRF_PICKING_PICKED,
  AMXL_PRF_PICKING_NOT_YET_PICKED,
  AMXL_PRF_PACKING,
  AMXL_PRF_SCANNED
};


export const STAGE = {
  BETA: "BETA",
  GAMMA: "GAMMA",
  PROD: "PROD"
};

export const REGION = {
  NA: "NA",
  EU: "EU",
  JP: "JP",
  IN: "IN"
};

export const MISSION_CONTROL_BASE_URL_MAP = {
  BETA: {
    NA: "https://beta-na-mc-execute.corp.amazon.com",
    EU: "https://beta-na-mc-execute.corp.amazon.com",
    JP: "https://beta-na-mc-execute.corp.amazon.com",
  },
  GAMMA: {
    NA: "https://gamma-na-mc-execute.corp.amazon.com",
    EU: "https://gamma-eu-mc-execute.corp.amazon.com",
    JP: "https://gamma-fe-mc-execute.corp.amazon.com",
  },
  PROD: {
    NA: "https://na-mc-execute.corp.amazon.com",
    EU: "https://eu-mc-execute.corp.amazon.com",
    JP: "https://fe-mc-execute.corp.amazon.com",
  }
};

export const AMAZON_SUFFIX = "@amazon.com";

export const TIMEOUT_STRING = "timeout";

export const PROCESS_PATHS = {
  "INBOUND": "INBOUND",
  "SORTATION": "SORTATION",
  "OUTBOUND": "OUTBOUND",
  "OTR": "OTR",
  "SAFETY": "SAFETY",
  "OPS-IMPROVEMENT-ANNOUNCEMENTS": "OPS-IMPROVEMENT-ANNOUNCEMENTS",
  "PEOPLE": "PEOPLE"
};

export const TASK_PRIORITY = {
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
  AT_RISK: "AT_RISK",
  LATE: "LATE",
  CRITICAL: "CRITICAL",
};

export const ERROR_MSG_500 = "Something is wrong...";

export const TASK_STATUS = {
  ACTIVE: "ACTIVE",
  STARTED: "STARTED",
  RESOLVED: "RESOLVED"
};

export const TASK_TYPE = {
  TRAINING_VIOLATION: "TRAINING_VIOLATION",
  TRAINING: "TRAINING",
  COACHING: "COACHING",
  FLOW_MANAGEMENT: "FLOW_MANAGEMENT",
  WEATHER: "WEATHER",
  START_OF_SHIFT_STANDARD_WORK: "START_OF_SHIFT_STANDARD_WORK",
  ASSOCIATE_ENGAGEMENT: "ASSOCIATE_ENGAGEMENT",
  ASSOCIATE_SAFETY: "ASSOCIATE_SAFETY",
  HELP_REQUEST: "HELP_REQUEST"
};

export const ISSUE_TYPE_OPTIONS = {
  NO_PROBLEMS: "noProblems",
  PROBLEM_ALREADY_FIXED: "problemAlreadyFixed",
  CREATED_BY_MISTAKE: "createdByMistake",
  SUBMITTED_THROUGH_WRONG_PROCESS: "submittedThroughWrongProcess"
}

export const REQUEST_TYPE_OPTIONS = {
  TRASH_AND_OTHER_SAFETY_HAZARDS: "trashAndOtherSafetyHazards",
  OVERFLOW_IN_PICK_TO_BUFFER_AREAS: "overflowInPickToBufferAreas",
  NEED_HELP_STOWING: "needHelpStowing",
  PROBLEM_SOLVE_ASSISTANCE: "problemSolveAssistance",
  LOW_ON_SUPPLY: "lowOnSupply",
  SOMETHING_ELSE: "somethingElse"
}

export const EXCLUDED_TASK_ATTRIBUTES = [
  "expiresAt"
];

export const EMPTY_STRING = "";
export const COMMA = ",";
export const COLON = ":";


// WEBPACK FOOTER //
// ./src/utils/Constants.js